
import XHeader from 'vux/src/components/x-header/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import {mapState,mapMutations} from 'vuex'
export default{
data(){
return{
msg: "",
show: false
}
},
components:{
XHeader,
Toast
},
created(){



this.SETTOKEN()

},
computed:{
...mapState(['userdetail','user','token','url'])
},
methods:{
...mapMutations(['SETUSERDETAIL','SETUSER','SETTOKEN',"CLEAN_ALL", 'CONNECT_WALLET']),

sendMsg(content) {
this.msg = content;
this.show = true;
},
},
}



// WEBPACK FOOTER //
// ./src/pages/allPages.vue